import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, List, Popup } from "antd-mobile";
import axios from "axios";
import style from "css/hotdesking.module.css";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import HotdeskingConfig from "../Config";
import dayjs from "dayjs";
import SearchTime from "./SearchTime";
import SearchCalendar from "./SearchCalendar";
import { useTranslation } from "react-i18next";

function SearchOptions({
  isOpen,
  onClose,
  setLocation,
  departmentId,
  date,
  setDate,
  time,
  setTime,
  isFind,
  setIsFind,
  serverDate,
  workTime,
  setDefaultLocation,
}) {
  const { t } = useTranslation();
  const [init, setInit] = useState(true);
  const [isListOpen, setIsListOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isTimeOpen, setIsTimeOpen] = useState(false);
  const [locationDepartmentList, setLocationDepartmentList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [parent, setParent] = useState(null);
  const [parentList, setParentList] = useState([]);
  const [child, setChild] = useState(null);
  const [children, setChildren] = useState([]);
  const [type, setType] = useState("");
  const [selectLocation, setSelectLocation] = useState(null);
  const [selectDate, setSelectDate] = useState(null);
  const [selectTime, setSelectTime] = useState({
    start: "",
    end: "",
  });

  const getLocationDepartmentList = useCallback(async () => {
    axios.get(`${HotdeskingConfig.baseURI}/location/department`).then((res) => {
      if (res.data !== "") {
        const list = [];
        res.data.forEach((item) => {
          list.push({
            value: item.id,
            label: item.name,
            parentId: item.parentId !== undefined ? item.parentId : "",
          });
        });
        setLocationDepartmentList(list);
      }
    });
  }, []);
  const getLocationList = useCallback(async () => {
    axios
      .get(`${HotdeskingConfig.baseURI}/location/list`)
      .then((res) => {
        setLocationList(res.data);
        res.data.forEach((item) => {
          if (item.defaultYn === "Y") {
            setDefaultLocation(item);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [setDefaultLocation]);
  const onSelectParent = useCallback(
    (selectKey) => {
      const childrenList = locationDepartmentList.filter(
        (item) => item.parentId === selectKey
      );
      if (childrenList.length < 1) {
        const location = locationList.filter(
          (item) => item.departmentId === selectKey
        );
        setSelectLocation(location[0]);
        setChildren([]);
        // setChild(null);
      } else {
        setSelectLocation(null);
        setChildren(childrenList);
      }
      setChild(null);
      setParent(
        locationDepartmentList.filter((item) => item.value === selectKey)[0]
      );
    },
    [locationDepartmentList, locationList]
  );
  const onSelectChild = useCallback(
    (selectKey) => {
      const location = locationList.filter(
        (item) => item.departmentId === selectKey
      );
      setSelectLocation(location[0]);
      setChild(
        locationDepartmentList.filter((item) => item.value === selectKey)[0]
      );
    },
    [locationDepartmentList, locationList]
  );
  const onFindDepartment = useCallback(() => {
    const department = locationDepartmentList.filter(
      (item) => item.value === departmentId
    )[0];

    if (department.parentId !== undefined && department.parentId !== "") {
      onSelectParent(department.parentId);
    }

    onSelectChild(department.value);
  }, [departmentId, locationDepartmentList, onSelectChild, onSelectParent]);

  const formatStartTime = useCallback(() => {
    if (date === serverDate) {
      const nowTime = dayjs(new Date()).format("HH:mm:ss");

      if (time.start > nowTime) {
        return dayjs(new Date(date + " " + time.start)).format("HH:mm:ss");
      }

      setTime({
        ...time,
        start: nowTime,
      });
      return dayjs(new Date()).format("HH:mm:ss");
    }
    return dayjs(new Date(date + " " + time.start)).format("HH:mm:ss");
  }, [date, serverDate, setTime, time]);

  useMemo(() => {
    getLocationDepartmentList();
    getLocationList();
  }, [getLocationDepartmentList, getLocationList]);

  useLayoutEffect(() => {
    if (isFind && departmentId !== null) {
      onFindDepartment();
      setIsFind(false);
    }
  }, [departmentId, isFind, onFindDepartment, setIsFind]);

  // useLayoutEffect(() => {
  //   if (isOpen && location !== null && selectLocation === null) {
  //     console.log(location);
  //   }
  // }, [isOpen, location, selectLocation]);

  useEffect(() => {
    if (isOpen && init) {
      setSelectDate(date);
      setSelectTime({
        start: formatStartTime(),
        end: time.end,
      });

      if (locationDepartmentList.length > 0 && parentList.length < 1) {
        setParentList(
          locationDepartmentList.filter((item) => item.parentId === "")
        );
      }

      setInit(false);
    }
  }, [
    date,
    formatStartTime,
    init,
    isOpen,
    locationDepartmentList,
    parentList.length,
    time.end,
  ]);

  useEffect(() => {
    if (!isOpen && !init) {
      setInit(true);
    }
  }, [init, isOpen]);

  const onSearch = () => {
    if (selectLocation !== null) {
      setLocation(selectLocation);
    }
    setTime(selectTime);
    setDate(selectDate);
    onClose();
  };
  //장소
  const onListOpen = (type) => {
    setType(type);
    setIsListOpen(true);
  };
  const onListClose = () => {
    setType("");
    setIsListOpen(false);
  };
  //캘린더
  const onCalendarOpen = () => {
    setIsCalendarOpen(true);
  };
  const onCalendarClose = () => {
    setIsCalendarOpen(false);
  };
  const onCalendarSelect = (selectDate) => {
    const date = dayjs(new Date(selectDate)).format("YYYY-MM-DD");
    setSelectDate(dayjs(new Date(date)).format("YYYY-MM-DD"));

    if (date !== serverDate) {
      setSelectTime({
        start: workTime.start,
        end: workTime.end,
      });
    } else {
      const currentTime = dayjs(new Date()).format("HH:mm");
      const time = {
        start: "",
        end: "",
      };

      if (currentTime < workTime.start) {
        time.start = workTime.start;
      } else {
        time.start = currentTime;
      }

      if (currentTime < workTime.end) {
        time.end = workTime.end;
      } else {
        time.end = dayjs(new Date(date + " " + time.start))
          .add(60, "minute")
          .format("HH:mm");
      }

      setSelectTime(time);
    }
    onCalendarClose();
  };
  //시간
  const onTimeOpen = (type) => {
    setType(type);
    setIsTimeOpen(true);
  };
  const onTimeClose = () => {
    setType("");
    setIsTimeOpen(false);
  };
  const onTimeSelect = (time) => {
    if (selectDate !== serverDate) {
      if (type === "start") {
        setSelectTime({
          ...selectTime,
          start: time,
        });
      } else {
        setSelectTime({
          ...selectTime,
          end: time,
        });
      }
    } else {
      if (type === "start") {
        const currentTime = dayjs(new Date()).format("HH:mm");

        if (time < currentTime) {
          setSelectTime({
            ...selectTime,
            start: currentTime,
          });
        } else {
          setSelectTime({
            ...selectTime,
            start: time,
          });
        }
      } else {
        if (time < selectTime.start) {
          setSelectTime({
            ...selectTime,
            end: dayjs(new Date(selectDate + " " + selectTime.start))
              .add(60, "minute")
              .format("HH:mm"),
          });
        } else {
          setSelectTime({
            ...selectTime,
            end: time,
          });
        }
      }
    }
    onTimeClose();
  };
  return (
    <>
      <ListPopup
        isOpen={isListOpen}
        onClose={onListClose}
        onSelect={type === "child" ? onSelectChild : onSelectParent}
        list={type === "child" ? children : parentList}
      />
      <SearchCalendar
        isOpen={isCalendarOpen}
        onClose={onCalendarClose}
        onSelect={onCalendarSelect}
        date={selectDate}
      />
      <SearchTime
        isOpen={isTimeOpen}
        onClose={onTimeClose}
        onSelect={onTimeSelect}
        time={type === "start" ? selectTime.start : selectTime.end}
        type={type}
      />

      <Popup
        className={`${style.popup} ${style.search}`}
        visible={isOpen}
        onMaskClick={onClose}
      >
        <section className={style.popup_wrapper}>
          <section className={style.popup_container}>
            <section className={style.popup_header}>
              <LeftOutlined className={style.header_icon} onClick={onClose} />
              <p>{t("HOTDESKING.MODAL.SEARCH.TITLE")}</p>
              <CheckOutlined
                className={`${style.header_icon} ${style.active}`}
                onClick={onSearch}
              />
            </section>
            <section className={style.popup_content}>
              <div className={style.popup_content_item}>
                <p className={style.content_item_title}>
                  {t("HOTDESKING.MODAL.SEARCH.LOCATION")}
                </p>
                <Button
                  className={style.content_item_indicator}
                  onClick={() => onListOpen("parent")}
                >
                  {parent !== null ? parent.label : ""}
                </Button>
                {children.length > 0 && (
                  <Button
                    className={style.content_item_indicator}
                    onClick={() => onListOpen("child")}
                  >
                    {child !== null ? child.label : ""}
                  </Button>
                )}
              </div>
              <div className={style.popup_content_item}>
                <p className={style.content_item_title}>
                  {t("HOTDESKING.MODAL.SEARCH.DATE")}
                </p>
                <Button
                  className={style.content_item_indicator}
                  onClick={onCalendarOpen}
                >
                  {selectDate !== null && selectDate}
                </Button>
              </div>
              <div className={style.popup_content_item}>
                <p className={style.content_item_title}>
                  {t("HOTDESKING.MODAL.SEARCH.TIME")}
                </p>
                <section className={style.content_item_grid}>
                  {selectTime !== null && (
                    <>
                      <Button
                        className={style.content_item_indicator}
                        onClick={() => onTimeOpen("start")}
                      >
                        <p>
                          {dayjs(
                            new Date(selectDate + " " + selectTime.start)
                          ).format("HH:mm")}
                        </p>
                      </Button>
                      <p>-</p>
                      <Button
                        className={style.content_item_indicator}
                        onClick={() => onTimeOpen("end")}
                      >
                        <p>
                          {dayjs(
                            new Date(selectDate + " " + selectTime.end)
                          ).format("HH:mm")}
                        </p>
                      </Button>
                    </>
                  )}
                </section>
              </div>
            </section>
          </section>
        </section>
      </Popup>
    </>
  );
}

export default SearchOptions;

function ListPopup({ isOpen, onClose, onSelect, list }) {
  const onClick = (key) => {
    onSelect(key);
    onClose();
  };
  return (
    <Popup
      className={`${style.popup} ${style.list}`}
      visible={isOpen}
      onMaskClick={onClose}
      onClose={onClose}
    >
      <section className={style.popup_wrapper}>
        <section className={style.popup_container}>
          <List className={style.popup_list}>
            {list.map((item) => (
              <List.Item
                key={item.value}
                onClick={() => onClick(item.value)}
                arrowIcon={false}
              >
                {item.label}
              </List.Item>
            ))}
          </List>
        </section>
      </section>
    </Popup>
  );
}
